export const DragScroll = {
  mounted() {
    const el = this.el;
    let isDown = false;
    let startX;
    let scrollLeft;
    let velX = 0;
    let momentumId = null;
    let dragged = false;
    let active = false;

    const DRAG_THRESHOLD = 5;

    const isScrollable = () => el.scrollWidth > el.clientWidth + 1;

    const activate = () => {
      if (active) return;
      active = true;
      el.classList.add("drag-scroll");
      el.style.cursor = "grab";
    };

    const deactivate = () => {
      if (!active) return;
      active = false;
      isDown = false;
      cancelMomentum();
      el.classList.remove("drag-scroll");
      el.style.cursor = "";
      el.style.userSelect = "";
    };

    const checkScrollable = () => {
      if (isScrollable()) {
        activate();
      } else {
        deactivate();
      }
    };

    // React to layout/size changes
    this._resizeObserver = new ResizeObserver(checkScrollable);
    this._resizeObserver.observe(el);
    checkScrollable();

    // Prevent native browser drag on links/images so our scroll handler stays in control
    el.addEventListener("dragstart", (e) => {
      if (active) e.preventDefault();
    });

    el.addEventListener("mousedown", (e) => {
      if (!active) return;
      if (e.button !== 0) return;

      isDown = true;
      dragged = false;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      velX = 0;
      cancelMomentum();
      el.style.cursor = "grabbing";
      el.style.userSelect = "none";
    });

    el.addEventListener("mouseleave", () => {
      if (isDown) {
        isDown = false;
        el.style.cursor = "grab";
        el.style.userSelect = "";
        beginMomentum();
      }
    });

    el.addEventListener("mouseup", () => {
      if (isDown) {
        isDown = false;
        el.style.cursor = "grab";
        el.style.userSelect = "";
        beginMomentum();
      }
    });

    el.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const dx = x - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) {
        dragged = true;
      }
      velX = dx - (scrollLeft - el.scrollLeft);
      el.scrollLeft = scrollLeft - dx;
    });

    // Prevent click on links after dragging
    el.addEventListener(
      "click",
      (e) => {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      },
      true,
    );

    function beginMomentum() {
      cancelMomentum();
      momentumId = requestAnimationFrame(momentumLoop);
    }

    function cancelMomentum() {
      if (momentumId) {
        cancelAnimationFrame(momentumId);
        momentumId = null;
      }
    }

    function momentumLoop() {
      el.scrollLeft -= velX;
      velX *= 0.92;
      if (Math.abs(velX) > 0.5) {
        momentumId = requestAnimationFrame(momentumLoop);
      }
    }
  },

  destroyed() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  },
};
